import { Component, EventEmitter, Output } from "@angular/core";

@Component({
  selector: "app-search-input",
  templateUrl: "./search-input.component.html",
  standalone: false,
})
export class SearchInputComponent {
  public search = "";
  public showClearIcon = false;

  @Output() searchChanged = new EventEmitter<string>();

  onSearchChange(searchTerm: string): void {
    this.searchChanged.emit(searchTerm);
    this.showClearIcon = searchTerm.length > 0;
  }

  clearSearch(): void {
    this.search = "";
    this.showClearIcon = false;
    this.searchChanged.emit("");
  }

  onSearchInput() {
    this.showClearIcon = false;
  }
}
